import styled from "styled-components";

export const Container = styled.div`
  background-color: rgba(0, 0, 0, 0.45);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
`;
